import { render } from "./productsComponent.vue?vue&type=template&id=9bb2773a"
import script from "./productsComponent.vue?vue&type=script&lang=js"
export * from "./productsComponent.vue?vue&type=script&lang=js"

import "./productsComponent.vue?vue&type=style&index=0&id=9bb2773a&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__